import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Customer } from '../customer.model';
import { OptionService } from '../option.service';
import { LocalStorageService } from 'ngx-webstorage';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MandoobService } from '../mandoobs/mandoob.service';
import { Globle } from 'src/assets/globle';
import { AppNotification } from './notification.model';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css'],
  queries: {
    contentRef: new ViewChild("ModalConfirmDelete"),
  },
})
export class NotificationsComponent implements OnInit {

  customers: Customer[] = [];
  userLoginId!: string;
  title!: string;
  body!: string;
  selectAll: boolean = false;
  selectAllType: boolean = false;
  form!: FormGroup;
  spinnerOverlay = false;
  selectedCustomers: string[] = [];
  selectedMandoobs: string[] = [];
  _selectedCustomers: string[] = [];
  _selectedMandoobs: string[] = [];
  mandoobs: Customer[] = [];
  usersType: { id: number, name: string }[] = [{ id: 1, name: 'customers' }, { id: 2, name: 'MandoobsMenu' }];
  selectedUserType = 1;

  notifications: AppNotification[] = [];
  displayedColumns: string[] = ['createDate', 'title', 'message', 'delete'];
  dataSource!: MatTableDataSource<AppNotification>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  public contentRef!: TemplateRef<any>;
  selectedNotificationId!: number;
  pageSize = 100;

  constructor(private optionService: OptionService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private mandoobService: MandoobService,
    private localStorage: LocalStorageService,
    private dialog: MatDialog,
    private globle: Globle) {
  }

  ngOnInit(): void {
    this.pageSize = this.globle.pageSize;
    this.getCustomers();
    this.getManddobs();
    this.getNotifications();
  }

  getNotifications() {
    this.spinnerOverlay = true;
    this.optionService.getNotifications().subscribe(data => {
      this.notifications = data.sort((a, b) => b.id - a.id);
      this.dataSource = new MatTableDataSource(this.notifications);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getCustomers() {
    this.userLoginId = this.localStorage.retrieve("userInfo").userId;
    this.optionService.getAllCustomers(this.userLoginId).subscribe(data => {

      for (let i = 0; i < data.length; i++) {
        let customer = {} as Customer;
        customer.id = data[i]['id'];
        customer.fullName = data[i]['fullName'];
        customer.userName = data[i]['userName'];
        customer.email = data[i]['email'];
        customer.balance = data[i]['balance'];
        customer.dept = data[i]['dept'];
        customer.approved = data[i]['approved'];
        customer.userCategoryId = data[i]['userCategoryId'];
        customer.newBallance = data[i]['newBallance'];
        customer.fcmRegToken = data[i]['fcmRegToken'];
        if (customer.approved == 1) {
          this.customers.push(customer);
        }
      }

    }, error => {
      console.log(error);
    })
  }

  getManddobs() {
    this.mandoobService.getAll().subscribe(data => {
      this.mandoobs = data
    }, error => {
      console.log(error)
    })
  }

  fillDataPost(): any {

    var selectedUsers: string[] = [];

    if (this._selectedCustomers.length > 0 && this._selectedMandoobs.length > 0) {
      selectedUsers = this._selectedCustomers.concat(this._selectedMandoobs);
    }
    else if (this._selectedCustomers.length > 0) {
      selectedUsers = this._selectedCustomers;
    }
    else {
      selectedUsers = this._selectedMandoobs;
    }
    var obj =
    {
      "title": this.title,
      "message": this.body,
      "usersIds": selectedUsers,
      "createBy": this.userLoginId
    }
    return obj;
  }

  sendFirebaseNotification() {

    this._selectedCustomers = [];
    this._selectedMandoobs = [];
    if (this.selectAllType) {
      this._selectedCustomers = this.customers.map(({ id }) => id);
      this._selectedMandoobs = this.mandoobs.map(({ id }) => id);
    }
    else {

      if (this.selectedUserType == 1) {
        if (this.selectAll) {
          this._selectedCustomers = this.customers.map(({ id }) => id);
        }
        else {
          this._selectedCustomers = this.selectedCustomers;
        }
      }

      if (this.selectedUserType == 2) {
        if (this.selectAll) {
          this._selectedMandoobs = this.mandoobs.map(({ id }) => id);
        }
        else {
          this._selectedMandoobs = this.selectedMandoobs;
        }
      }
    }

    this.spinnerOverlay = true;
    var obj = this.fillDataPost();

    this.optionService.createNotifications(obj).subscribe(data => {
      this.openSnackBar(this.translateService.instant("sendSuccessfully"), 'snackBarSuccess');
      this.title = '';
      this.body = '';
      this.getNotifications();
      this.spinnerOverlay = false;

    },
      error => {
        console.log(error)
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }
        this.spinnerOverlay = false;
      });

  }

  submit() {
    this.sendFirebaseNotification();
  }

  onDelete(id: number) {
    this.selectedNotificationId = id;
    this.openDialogConfirmDelete();
  }

  confirmDelete() {
    this.dialog.closeAll();
    this.spinnerOverlay = true;
    this.optionService.deleteNotification(this.selectedNotificationId).subscribe(() => {
      this.openSnackBar(this.translateService.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.getNotifications();
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
      if (error.error?.message) {
        this.openSnackBar(error.error.message, 'snackBarError');
      } else {
        this.openSnackBar("Internal server error", 'snackBarError');
      }
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  openDialogConfirmDelete(): void {
    this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  userTypeChange() {
    this.selectedMandoobs = [];
    this.selectedCustomers = [];

  }
}
